import axios from "@/axios";
import { defineStore } from "pinia";

export const useImportStore = defineStore("importStore", {
  state: () => ({
    importing: false,
    importDone: 0,
    importTotal: 0,
  }),
  actions: {
    async start() {
      this.startImporting();
      try {
        await axios.post("/api/importdatas/start");
        return null;
      } catch (e) {
        this.stopImporting();
        console.error(e);
        return e;
      }
    },
    startImporting() {
      this.importing = true;
    },
    stopImporting() {
      this.importing = false;
    },
    importProgressDone(done) {
      this.importDone = done;
    },
    importProgressTotal(total) {
      this.importTotal = total;
    },
  },
});
